// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://thrively-app.com/thrivelyapi_test/Api",
  verificationUrl: "https://sandbox.myidentitypass.com",
  "paystackKey": "pk_test_9b9def21c29fca870fb87864b642edf39e417c52"
  // testVerificationUrl: "https://sandbox.myidentitypass.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 * https://api.myidentitypay.com/api/v2/biometrics/merchant/data/verification/bvn
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
